import React from 'react';
import { Box, Chip } from '@material-ui/core';
import AccountIcon from '@material-ui/icons/AccountCircle';
import { ContactDialog } from './ContactDialog';
import { Contact } from '../../models/interfaces';

interface ContactCellProps {
  contact: Contact;
}

export const ContactCell = (props: ContactCellProps) => {
  const { contact } = props;

  const [open, setOpen] = React.useState(false);

  const handleClick = async () => setOpen(true);
  const handleClose = () => setOpen(false);

  const usernameDefault = contact.username === '' ? contact.userId : contact.username;

  return (
    <Box display="inline-block" mr={1} mb={1}>
      <Chip
        icon={<AccountIcon />}
        label={usernameDefault}
        onClick={handleClick}
        variant="outlined"
      />
      <ContactDialog open={open} handleClose={handleClose} contact={contact} />
    </Box>
  );
};
